import { Action } from 'redux';

const LIVE_EVENTS_LIVE_VIDEO_STORAGE_KEY = 'catapult:liveEventsLiveVideo';

const getCachedLiveVideo = (): boolean => {
  if (!localStorage.getItem(LIVE_EVENTS_LIVE_VIDEO_STORAGE_KEY)) {
    localStorage.setItem(LIVE_EVENTS_LIVE_VIDEO_STORAGE_KEY, true.toString());
    return true;
  }
  return localStorage.getItem(LIVE_EVENTS_LIVE_VIDEO_STORAGE_KEY) === 'true';
};

export enum ActionType {
  ToggleLiveVideo = 'LiveEvents.ToggleLiveVideo',
}

export interface ILiveEventsAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  isLiveVideo: boolean;
}

const INITIAL_STATE: IState = {
  isLiveVideo: getCachedLiveVideo(),
};

export default function reducer(state: IState = INITIAL_STATE, action: ILiveEventsAction): IState {
  switch (action.type) {
    case ActionType.ToggleLiveVideo:
      localStorage.setItem(LIVE_EVENTS_LIVE_VIDEO_STORAGE_KEY, (!state.isLiveVideo).toString());
      return {
        ...state,
        isLiveVideo: !state.isLiveVideo,
      };
    default:
      return state;
  }
}

export const toggleLiveVideo = () => ({
  type: ActionType.ToggleLiveVideo,
});
